/**
 * P-19a item 7 — D-145 / D-146 (Q-100): the employee's pop-up for a ticket
 * that reaches them: sent to them by the customer, a new portal ticket of a
 * customer they manage (D-144), assigned or forwarded to them ("שליחה לעובד
 * אחר"). A customer's reply is the chat bubble (ChatNotificationDock). Built on
 * the existing notifications (the same 5 s poll). Pure; unit-tested in
 * src/utils/__tests__/ticketArrivalModel.test.ts.
 */
import type { Notification } from '../../types';

export type ArrivalKind = 'new' | 'forwarded' | 'assigned';

export interface TicketArrival {
  id: string;
  ticketId: string;
  kind: ArrivalKind;
  title: string;
  from: string;
  note: string;
}

export function toTicketArrival(n: Notification): TicketArrival | null {
  if (!n.ticket_id) return null;
  const m = (n.metadata ?? {}) as Record<string, unknown>;
  const str = (v: unknown) => (typeof v === 'string' ? v : '');
  const title = str(m.ticket_title) || str(m.title) || n.ticket_title || '';
  let kind: ArrivalKind | null = null;
  if (n.event_type === 'ticket_forwarded') kind = 'forwarded';
  else if (n.event_type === 'ticket_assigned') kind = 'assigned';
  else if (n.event_type === 'ticket_created' && (m.addressed_to_you === true || m.as_account_manager === true || m.source === 'portal')) kind = 'new';
  if (!kind) return null;
  return {
    id: n.id,
    ticketId: n.ticket_id,
    kind,
    title,
    from: kind === 'forwarded' ? str(m.sender_name) : (n.organization_name || ''),
    note: kind === 'forwarded' ? str(m.message_preview) : '',
  };
}

/**
 * The arrivals not seen before. The first poll only learns what is already
 * there (no pop-up for old notifications); read ones never pop up.
 */
export function newArrivals(list: Notification[], known: Set<string>, initialized: boolean): TicketArrival[] {
  const out: TicketArrival[] = [];
  for (const n of list) {
    if (known.has(n.id)) continue;
    known.add(n.id);
    if (!initialized || n.read_at) continue;
    const a = toTicketArrival(n);
    if (a) out.push(a);
  }
  return out;
}
